import { Currency } from '@lib/services/models';

import client from '@services/client';

import { SocialAccount, UpdatePidDto, UpdatePlayerDto } from '../_api';

export const getUser = (id: string, environment: string) => {
  return client.api.csUserControllerGetUser(id, { environment });
};

export const getSocialAccounts = (userId: string, environment: string) => {
  return client.api.csUserControllerGetSocialAccounts(userId, { environment });
};

export const updateUser = (id: string, environment: string, data: UpdatePlayerDto) => {
  return client.api.csUserControllerUpdateUser(id, { environment }, data);
};

export const updatePidUser = (id: string, environment: string, data: UpdatePidDto) => {
  return client.api.csUserControllerUpdatePidUser(id, { environment }, data);
};

export const getCurrencies = (userId: string, environment: string) => {
  return client.api.csUserControllerGetCurrencies(userId, { environment });
};

export const removeCurrency = (userId: string, environment: string, currency: string) => {
  return client.api.csUserControllerRemoveCurrency(userId, { environment, currency });
};

export const updateCurrency = (userId: string, environment: string, currency: Currency) => {
  return client.api.csUserControllerUpdateCurrency(userId, { environment }, currency);
};

export const createCurrency = (userId: string, environment: string, currency: Currency) => {
  return client.api.csUserControllerAddCurrency(userId, { environment }, currency);
};

export const removeSocialAccount = (userId: string, environment: string, connect: string) => {
  return client.api.csUserControllerRemoveSocialAccount(userId, { environment, connect });
};

export const addSocialAccount = (
  userId: string,
  environment: string,
  socialAccount: SocialAccount,
) => {
  return client.api.csUserControllerAddSocialAccount(userId, { environment }, socialAccount);
};

export const getBlueprintData = (
  userId: string,
  environment: string,
  type: string,
  variant?: string,
) => {
  return client.api.csUserControllerGetBlueprintData(userId, type, { environment, variant });
};
